import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

const rootElement = document.getElementById('root')

// Ensure page always starts at top (belt-and-suspenders alongside index.html scrollRestoration=manual)
window.scrollTo(0, 0)

// Does the pre-rendered snapshot we were served actually correspond to this URL?
// Firebase's catch-all rewrite hands out the "/" snapshot for any route we don't
// pre-render, in which case the markup on screen is the wrong page.
const normalise = (p) => (p.length > 1 ? p.replace(/\/+$/, '') : p)
const snapshotRoute = document.querySelector('meta[name="prerendered-route"]')?.content
const snapshotMatchesUrl =
  !!snapshotRoute && normalise(snapshotRoute) === normalise(window.location.pathname)

// The client always does a fresh render rather than hydrating, so React's first
// commit replaces whatever is in #root. When the snapshot is for this URL we leave
// it on screen until that happens: clearing it up front blanked the page for the
// ~1s the initial render takes, which read as a white flash between the snapshot
// and the live app. When it's the wrong page, clear it — a stale marketing homepage
// under, say, /dashboard is worse than a brief blank.
if (!snapshotMatchesUrl && rootElement.hasChildNodes()) {
  rootElement.innerHTML = ''
}

// Body classes set by the pre-renderer (e.g. homepage-active) must not persist onto
// a different route. Home.jsx re-adds it via useLayoutEffect when it actually renders.
if (!snapshotMatchesUrl) {
  document.body.className = ''
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Dispatch event to signal that rendering is complete (for pre-renderer)
// Wait for react-helmet-async to update the document head
const waitForHelmet = () => {
  const defaultTitle = 'TeachESLPro - Teaching English just got easier'
  let attempts = 0
  const maxAttempts = 20

  const check = () => {
    attempts++
    if (document.title !== defaultTitle || attempts >= maxAttempts) {
      document.dispatchEvent(new Event('render-event'))
    } else {
      setTimeout(check, 50)
    }
  }

  setTimeout(check, 100)
}

waitForHelmet()
